/*
We want the first child, and the first child of the first child, and the first child of the first child of the first child, and so on, to have no top margin.

> *:first-child,
> *:first-child > *:first-child,
> *:first-child > *:first-child > *:first-child,

also to skip the module marker
> script:first-child + *,
> script:first-child + * > *:first-child,
> script:first-child + * > *:first-child > *:first-child,
*/

const DEPTH = 5

const generateSelector = (level, selector = '> *:first-child', firstSelector = selector) =>
  Array(level)
    .fill()
    .map((_, i) =>
      Array(i + 1)
        .fill()
        .map((_, j) => (j === 0 ? firstSelector : selector))
        .join(' '),
    )
    .join(', ')

const richTextStyles = {
  [generateSelector(DEPTH, '> *:first-child')]: {
    mt: 0,
  },
  [generateSelector(DEPTH, '> *:first-child', '> script:first-child + *')]: {
    mt: 0,
  },
  [generateSelector(DEPTH, '> *:last-child')]: {
    mb: 0,
  },
}

export default richTextStyles
